export const hasSlot = (menuItem) => !!menuItem.slot;
const getRegularItems = (menuData) => menuData.items.filter(item => !hasSlot(item));
const getSlotItems = (menuData) => menuData.items.filter(item => hasSlot(item));
export const hasSubSubItems = (menuItem) => !!menuItem.items?.some(item => !!item.items?.length);
export const containsSubmenusInRegularItems = (menuData) => {
    const regularItems = getRegularItems(menuData);
    return getTreeDepth({ ...menuData, items: regularItems }) >= 2;
};
export const containsNestedSubmenusInRegularItems = (menuData) => {
    const regularItems = getRegularItems(menuData);
    return getTreeDepth({ ...menuData, items: regularItems }) === 3;
};
export const containsNestedSubmenusInSlotItems = (menuData) => {
    const slotItems = getSlotItems(menuData);
    return getTreeDepth({ ...menuData, items: slotItems }) === 3;
};
const getTreeDepth = (tree) => {
    let depth = 1;
    const setDepth = (list, newDepth = 1) => {
        if (depth < newDepth) {
            depth = newDepth;
        }
        list.forEach((listItem) => {
            if (listItem?.items?.length > 0) {
                return setDepth(listItem.items, newDepth + 1);
            }
        });
    };
    setDepth(tree.items);
    return depth;
};
//# sourceMappingURL=items.js.map